import { render, staticRenderFns } from "./CommonAside.vue?vue&type=template&id=ea729922&scoped=true"
import script from "./CommonAside.vue?vue&type=script&lang=js"
export * from "./CommonAside.vue?vue&type=script&lang=js"
import style0 from "./CommonAside.vue?vue&type=style&index=0&id=ea729922&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ea729922",
  null
  
)

export default component.exports